import { Component, OnInit, Compiler } from '@angular/core';
import { WebApiObservableService } from 'app/web-api-observable/web-api-observable.service';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Router } from '@angular/router';
import { PushNotificationsService } from 'angular2-notifications';
@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css']
})
export class CheckoutComponent implements OnInit {

  constructor( private _pushNotifications: PushNotificationsService,private CheckoutService: WebApiObservableService, private _compiler: Compiler, private router: Router, private _sanitizer: DomSanitizer) {

     _pushNotifications.requestPermission();
   }
  loggedinUser: any = [];
  shoppingCart: any = [];
  addresses: any = [];
  errorMessage: any = [];
  newAddress: any = {};
  editnewAddress: any = {};
  finalOrder: any = {};
  foods: any = [];
  foods_ordered: any = [];
  terms: any;
  colonies: any = [];
  ngOnInit() {
    this.loggedinUser = JSON.parse(localStorage.getItem('LOGGED_IN_USER'));
    this.shoppingCart = JSON.parse(localStorage.getItem('SHOPPING_CART'));

    this.foods = this.shoppingCart[0].fooditems;
    for (let i = 0; i < this.foods.length; i++) {
      this.foods_ordered.push({ 'food_id': this.foods[i].food.id, 'price': this.foods[i].food.price, 'qty': this.foods[i].food.itemsval, 'sub_total': this.foods[i].food.priceVal, 'addons': this.foods[i].addons })

    }
    $('.spin').addClass('loading');
    // get colonies
    this.CheckoutService.getServiceForSearch('/colonies', 'pagesize', '700')
      .subscribe(
      result => {
        this.colonies = result.items;
      },
      error => {
        this.errorMessage = error.message;
      }
      );
    this._compiler.clearCache();
    let token = localStorage.getItem('AUTH_TOKEN');
    // get addresses
    this.CheckoutService
      .searchaddress('/customeraddressservices', 'customer_id', this.loggedinUser.id, token)
      .subscribe(
      result => {
        this.addresses = result.items;
        $('.spin').removeClass('loading');
      },
      error => {
        this.errorMessage = error.message;
        $('.spin').removeClass('loading');
      }
      );
  }

  autocompleListFormatter = (data: any): SafeHtml => {
    let html = `<span>${data.area}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  addAddress() {
    $('.spin').addClass('loading');
    this.newAddress.customer_id = this.loggedinUser.id;
    let token = localStorage.getItem('AUTH_TOKEN');
    this.newAddress.colony_id = this.newAddress.colony.id;

    let finalAddress = {
      address: this.newAddress.address,
      area: this.newAddress.area,
      colony_id: this.newAddress.colony.id,
      customer_id: this.newAddress.customer_id,
      landmark: this.newAddress.landmark,
      street: this.newAddress.street
    };
    this.CheckoutService
      .createAddress('/customeraddressservices', finalAddress, token)
      .subscribe(
      result => {
        this.CheckoutService
          .searchaddress('/customeraddressservices', 'customer_id', this.loggedinUser.id, token)
          .subscribe(
          result => {
            this.addresses = result.items;
            alert('Address Added Successfully');
            $('.spin').removeClass('loading');
          },
          error => {
            $('.spin').removeClass('loading');
            this.errorMessage = error.message;
          }
          );
      },
      error => {
        $('.spin').removeClass('loading');
        this.errorMessage = error.message;
      }
      );
  }

  delete(deladdress) {
    $('.spin').addClass('loading');
    let token = localStorage.getItem('AUTH_TOKEN');
    this.CheckoutService
      .deleteServiceWithId('/customeraddressservices', deladdress.id, token)
      .subscribe(
      result => {
        this._compiler.clearCache();
        this.addresses = [];
        this.CheckoutService
          .searchaddress('/customeraddressservices', 'customer_id', this.loggedinUser.id, token)
          .subscribe(
          result => {
            this.addresses = result.items;
            alert('Address Deleted Successfully');
            $('.spin').removeClass('loading');
          },
          error => {
            $('.spin').removeClass('loading');
            this.errorMessage = error.message;
          }
          );
      },
      error => {
        $('.spin').removeClass('loading');
        this.errorMessage = error.message;
      }
      );
  }

  placeOrder() {
    this.finalOrder.customer_id = this.loggedinUser.id;
    this.finalOrder.delivery_charges = 10;
    this.finalOrder.total_charges = this.shoppingCart[0].total;
    this.finalOrder.customer_ordered = this.foods_ordered;
    this.finalOrder.transaction_id = '2043509';
    this.finalOrder.transaction_charges = 20;
    this.finalOrder.transaction_amount = 23;
    this.finalOrder.payment_status = 'paid';
    this.finalOrder.status = '1';
    this.finalOrder.payment_type='cod';

    if (!this.finalOrder.address_id) {
      alert('Please select the Address');
    }
    //  else if (!this.finalOrder.payment_type) {
    //   alert('Please select the payment method');
    // }
     else if (!this.terms) {
      alert('Please Check mark the terms');
    } else {
      $('.spin').addClass('loading');

      this.CheckoutService
        .createOrder('/customerorders/food-ordered', this.finalOrder)
        .subscribe(
        result => {

          localStorage.removeItem('SHOPPING_CART');
          localStorage.setItem('ORDER-PLACED', JSON.stringify(result));
          alert('Your order has been placed successfully');
          $('.spin').removeClass('loading');
          this.router.navigate(["order-placed"]);
        },
        error => {
          $('.spin').removeClass('loading');
          this.errorMessage = error.message;
        }
        );
    }
  }


  opencolonylist(colony) {
    console.log(colony);
  }

  editAddress(myModal, address) {
    myModal.open();
    this.editnewAddress = address;
  }

  finalAddress = {};
  updateAddress(myModal, id) {
    $('.editspin').addClass('loading');
    let token = localStorage.getItem('AUTH_TOKEN');
    this.finalAddress = {
      address: this.editnewAddress.address,
      area: this.editnewAddress.area,
      colony_id: this.editnewAddress.colony.id,
      customer_id: this.editnewAddress.customer_id,
      landmark: this.editnewAddress.landmark,
      street: this.editnewAddress.street
    };

    this.CheckoutService
      .updateAddress('/customeraddressservices/' + id, this.finalAddress, token)
      .subscribe(
      result => {
        myModal.close();
        $('.editspin').removeClass('loading');
        alert('Address Updated');
        let options = {
          body: 'Address Updated',
          icon: 'http://test.eatasiafood.com/uploads/logo/logo.png',
        }
        let notify = this._pushNotifications.create('Success', options).subscribe(
        );

      },
      error => {
        $('.editspin').removeClass('loading');
        this.errorMessage = <any>error
      }
      );
  }

}



// WEBPACK FOOTER //
// D:/deliverproject/eatasiafood/src/app/checkout/checkout.component.ts